import React, { ReactElement, useState } from 'react';
import InlineDialog, { Placement } from '../../../components/InlineDialog';
import usePopup from '../../../hooks/usePopup';
import Button, { ButtonSize, ButtonType } from '../Button';
import ContextMenuContext from './ContextMenuContext';
import Tooltip from '../../../components/Tooltip';
import { ContextMenuDiv } from './styles';
export { default as Option } from './Option';
export { default as Break } from './Break';
export { default as Info } from './Info';

const ContextMenu = ({
  children,
  testId,
  placement,
  buttonType = 'Secondary',
  onOpen,
  onClose,
  icon,
  label,
  tooltip,
  iconAfter,
  size = 'Small',
  isDisabled,
  disabledMessage,
}: {
  children: ReactElement | ReactElement[];
  testId?: string;
  placement?: Placement;
  buttonType?: ButtonType;
  onOpen?: () => void;
  onClose?: () => void;
  icon?: Kingpin.Icon;
  label?: string;
  tooltip?: string;
  iconAfter?: Kingpin.Icon;
  size?: ButtonSize;
  isDisabled?: boolean;
  // Shown as the trigger's tooltip while it is disabled.
  disabledMessage?: string;
}) => {
  const { isOpen, close, open } = usePopup();
  // I'm not mad on this pattern, but i'm under time pressure
  const [isHidden, setIsHidden] = useState(false);

  return (
    <ContextMenuContext.Provider
      value={{
        closeMenu: () => {
          close();
          if (onClose) {
            onClose();
          }
          setIsHidden(false);
        },
        hideMenu: () => {
          setIsHidden(true);
          if (onClose) {
            onClose();
          }
        },
      }}
    >
      <InlineDialog
        placement={placement}
        content={
          <ContextMenuDiv isHidden={isHidden}>{children}</ContextMenuDiv>
        }
        onClose={() => {
          close();
          setIsHidden(false);
          if (onClose) {
            onClose();
          }
        }}
        isOpen={isOpen}
      >
        <Tooltip content={tooltip}>
          <Button
            testId={testId}
            size={size}
            type={buttonType}
            isDisabled={isDisabled}
            isDisabledMessage={disabledMessage}
            icon={icon || 'dots-menu'}
            iconAfter={iconAfter}
            label={label}
            onClick={() => {
              if (isOpen) {
                close();
                setIsHidden(false);
                if (onClose) {
                  onClose();
                }
              } else {
                open();
                setIsHidden(false);
                if (onOpen) {
                  onOpen();
                }
              }
            }}
          />
        </Tooltip>
      </InlineDialog>
    </ContextMenuContext.Provider>
  );
};

export default ContextMenu;
